import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { FormField, CustomFormInput } from '../../../../../utils/FormFields';

function DocumentsTab({
  account, changedAccount, showChanges, fetchFile
}) {
  const editDocument = changedAccount.AccountArchives[0];
  let compareDocument;
  account.AccountArchives.map((r) => {
    if (parseInt(r.AccountArchiveId, 10) === parseInt(editDocument.AccountArchiveId, 10)) {
      compareDocument = r;
    }
    return {};
  });
  let color = 'black';
  if (showChanges && editDocument.AccountArchiveId > 0) {
    color = 'red';
  } else if (showChanges && parseInt(editDocument.AccountArchiveId, 10) === 0) {
    color = 'green';
  }

  const getFile = (file) => {
    const body = {
      fileId: file.AccountArchivesTemporalFileId
    }
    fetchFile(body, (response) => {
      var a = document.createElement('A');
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.AccountArchivesName}.${file.AccountArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500, fontSize: '20px', display: 'block', color,
      }}
      >
        {showChanges ? (
          <React.Fragment>
            {editDocument.AccountArchiveId > 0
              ? 'Remove Document'
              : 'New Document'}
          </React.Fragment>
        ) : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {parseInt(editDocument.AccountArchiveId, 10) === 0
              && <FormToShow document={editDocument} getFile={getFile} />}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareDocument && <FormToShow document={compareDocument} getFile={getFile}/>}
          </FormGroup>
        )}
    </Form>
  );
}

DocumentsTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default DocumentsTab;

const FormToShow = ({ document, getFile }) => (
  <React.Fragment>
    {document.AccountArchiveId > 0 && (
      <FormField
        name="AccountArchiveId"
        value={document.AccountArchiveId}
        label="Id"
      />
    )}
    <CustomFormInput label="File">
      {document.AccountArchivesTemporalFileId > 0 ?
        <a onClick= {() => getFile(document)} style = {{cursor:'pointer'}}>
        {`${document.AccountArchivesName}.${document.AccountArchivesExtension}`}
        </a>
      :
        <a href={`data:application/octet-stream;base64,${document.AccountArchivesBlob}`} download={`${document.AccountArchivesName}.${document.AccountArchivesExtension}`}>
          {`${document.AccountArchivesName}.${document.AccountArchivesExtension}`}
        </a>
      }
    </CustomFormInput>
    <FormField
      name="AccountArchivesType"
      value={document.AccountArchivesTypeDescription}
      label="Type"
    />
    <FormField
      name="AccountArchivesSubType"
      value={document.AccountArchivesSubTypeDescription}
      label="Sub Type"
    />
    {!document.AccountArchivesEnabled
      ? (
        <FormField
          name="AccountArchivesEnabled"
          value={!document.AccountArchivesEnabled ? 'Yes' : 'No'}
          label="Lifelong?"
        />
      ) : (
        <FormField
          name="PersonArchivesExpirationDate"
          value={new Date(document.AccountArchivesExpirationDate).toLocaleDateString('es')}
          label="Expiration Date: "
          type="date"
        />
      )}
  </React.Fragment>
);

FormToShow.propTypes = {
  document: PropTypes.object.isRequired,
};
